// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x39IT","right":"styles_right__2xuEn"};